<template>
  <v-container
    fluid
    class="pa-0 grey lighten-4"
    style="flex-direction: column; overflow: hidden"
  >
    <!-- Banner de Bloqueo / Vista por QR -->
    <v-alert
      v-if="modoBloqueadoQR"
      dense
      type="info"
      color="primary"
      class="mb-0 rounded-0"
      dark
    >
      <div class="d-flex align-center justify-space-between w-100">
        <div class="d-flex align-center">
          <v-icon left small>mdi-qrcode-scan</v-icon>
          <span class="text-caption font-weight-medium">
            Acceso restringido al armario: <strong>{{ nodoBloqueado?.name }}</strong>
          </span>
        </div>
      </div>
    </v-alert>

    <ArmariosToolbar
      :listaModo="listaModo"
      :isMobile="!$vuetify.breakpoint.mdAndUp"
      :verPlanos="modoBloqueadoQR ? false : puedeVerPlanos"
      :deshabilitarDrawer="modoBloqueadoQR"
      @toggle-drawer="!modoBloqueadoQR && (drawerOpen = !drawerOpen)"
      @change-modo="!modoBloqueadoQR && onChangeModo($event)"
      @open-scanner="!modoBloqueadoQR && (showScanner = true)"
      :verDocumentos="!modoBloqueadoQR && !!idCliente && esRamos"
      @open-docs-cliente="dialogDocsCliente = true"
      :numDocumentos="numDocsCliente"
      @open-historial="dialogHistorial = true"
      :verAyuda="!modoBloqueadoQR"
      @open-ayuda="dialogAyuda = true"
      :verCalidad="!modoBloqueadoQR && !!idCliente && puedeEditar"
      @open-calidad="dialogCalidad = true"
    />


    <div class="d-flex flex-grow-1" style="overflow: hidden">
      <ArmariosDrawer
        v-if="!modoBloqueadoQR"
        v-model="drawerOpen"
        :isDesktop="$vuetify.breakpoint.mdAndUp"
        :listaModo="listaModo"
        :treeData="treeDataVisible"
        :errorCarga="errorArbol"
        :selectedNode="selectedNode"
        :planosData="planosData"
        :selectedPlano="selectedPlano"
        @select-node="selectNode"
        @toggle-node="toggle"
        @select-plano="selectPlano"
        @plano-creado="fetchPlanos"
      />

      <main class="main-workspace flex-grow-1">
        <ArmariosTreeView
          ref="arbol"
          v-if="listaModo === 'armarios'"
          :treeData="treeDataVisible"
          :errorCarga="errorArbol"
          :cargando="cargandoArbol"
          :usuarios="usuarios"
          :selectedNode="selectedNode"
          :searchQueryId="treeSearchQuery"
          :verPlanos="modoBloqueadoQR ? false : puedeVerPlanos"
          :puedeEditar="puedeEditar"
          :puedeAdjuntar="puedeAdjuntar"
          :modoBloqueadoQR="modoBloqueadoQR"
          @cambiar-padre="cambiarPadre"
          @crear-armario-raiz="crearArmarioRaizFromChild"
          @reintentar-carga="fetchTree"
          @select-node="onIntentarSeleccionarNodo"
          @clear-selected="!modoBloqueadoQR && clearSelectedNode()"
          @update:searchQueryId="treeSearchQuery = $event"
          @add-subnode="crearHijo"
          @edit-title="editTitle"
          @remove-node="removeNode"
          @attach-file="attachFile"
          @view-files="viewFiles"
          @ver-plano="verPlano"
          @ver-qr="verQR"
          @toggle="toggle"
          @asignar-categoria="abrirAsignarCategoria"
          @editar-nota="abrirNota"
          @gestionar-categorias="dialogCategorias = true"
          @carpetas-en-bloque="abrirCarpetasEnBloque"
          :puedeGestionarCategorias="puedeGestionarCategorias"
          :puedeOrdenar="puedeOrdenar"
          @ordenar-hijos="abrirOrdenarHijos"
          @ordenar-raices="abrirOrdenarHijos({ id: null, name: null, children: treeData })"
          @categoria-en-bloque="asignarCategoriaEnBloque"
          @mover-en-bloque="abrirMoverEnBloque"
          @plegar-todo="cambiarDesplegadoTodo(false)"
          @desplegar-todo="cambiarDesplegadoTodo(true)"
        />

        <ArmariosPlanosView
          v-else-if="!modoBloqueadoQR"
          :selectedPlano="selectedPlano"
          :armarios="treeDataVisible"
          :planosData="planosData"
          @click_plano="click_plano"
          @ver-en-arbol="verArmarioEnArbol"
          @ver-en-plano="verArmarioEnPlano"
          @add-adjunto="openAttachFromAdjuntos"
          @ir-a-subplano="irASubPlano"
          @fetch="fetchTree"
        />
      </main>
    </div>
    
    <ArmariosDialogs
      :snackbar.sync="snackbar"
      :snackbarText="snackbarText"
      :snackbarColor="snackbarColor"
      :attachDialog.sync="attachDialog"
      :crearSubnodoDialog.sync="crearSubnodoDialog"
      :editarNodoDialog.sync="editarNodoDialog"
      :dialogPlanos.sync="dialogPlanos"
      :dialogElegirPlano.sync="dialogElegirPlano"
      :showScanner.sync="showScanner"
      :dialogVerQR.sync="dialogVerQR"
      :nodoParaQR="nodoParaQR"
      :nodoSeleccionadoParaAdjunto="nodoSeleccionadoParaAdjunto"
      :carpetasParaAdjunto="carpetasParaAdjunto"
      :carpetaParaAdjunto="carpetaParaAdjunto"
      :tiposNodo="tiposNodo"
      :bannerTipoSeleccionado="bannerTipoSeleccionado"
      :nodoEditando="nodoEditando"
      :selectedAdjuntos="selectedAdjuntos"
      :adjuntos="adjuntos"
      :articulos="articulos"
      :planoYposicion="planoYposicion"
      :selectedPlano="selectedPlano"
      :planosData="planosData"
      :nodoParaCrearHijo="nodoParaCrearHijo"
      :dialogSeleccionarArmario="dialogSeleccionarArmario"
      :armarios="treeDataVisible"
      :verPlanos="modoBloqueadoQR ? false : puedeVerPlanos"
      :puedeEditar="puedeEditar"
      :puedeAdjuntar="puedeAdjuntar"
      :puedeEliminar="puedeEliminarAdjunto"
      :bloqueado="modoBloqueadoQR"
      @upload="handleFileUpload"
      @save-subnode="guardarSubnodo"
      @guardar-edicion="guardarEdicionNodo"
      @cerrar-planos="cerrarDialogPlanos"
      @decode="onDecode"
      @imprimir-qr="imprimirQR"
      @close-adjuntos="closeAdjuntosLista"
      @refresh-adjuntos="refreshAdjuntos"
      @select-plano-store="selectPlanoStore"
      @plano-creado="fetchPlanos"
      @select="select"
      @crear-nuevo-tipo="crearNuevoTipo"
      @add-adjunto="openAttachFromAdjuntos"
      @ver-en-plano="verArmarioEnPlano"
      @ver-en-arbol="verArmarioEnArbol"
      @cambiar-estado-dialog="cambiarEstadoDialog"
      @cambiar-padre-de-armario="cambiarPadreDeArmario"
      @ir-a-subplano="irASubPlano"
      @fetch="fetchTree"
    />

    <DialogAdjuntosCliente
      :dialog.sync="dialogDocsCliente"
      :idCliente="idCliente"
      :puedeAdjuntar="puedeAdjuntar"
      :puedeEliminar="puedeEliminarAdjunto"
      @notificar="notificar"
      @total="numDocsCliente = $event"
    />

    <DialogCategoriasArmarios
      :dialog.sync="dialogCategorias"
      @cambiado="fetchCategorias"
      @notificar="notificar"
    />

    <DialogCalidadDatos
      :dialog.sync="dialogCalidad"
      :idCliente="idCliente"
      :arbol="treeData"
      :planos="planosData"
      :puedeEditar="puedeEditar"
      :verPlanos="puedeVerPlanos"
      @ver-armario="dialogCalidad = false; verArmarioEnArbol({ id: $event })"
      @ver-documentos="viewFiles"
      @asignar-categoria="abrirAsignarCategoria"
      @abrir-plano="dialogCalidad = false; selectPlano($event)"
    />

    <DialogAyuda
      :dialog.sync="dialogAyuda"
      :editor="puedeEditar"
      :editorPlanos="(permisos || []).includes('editar-planos')"
      :verPlanos="puedeVerPlanos"
      :puedeAdjuntar="puedeAdjuntar"
      :esRamos="esRamos"
    />

    <DialogHistorialCliente
      :dialog.sync="dialogHistorial"
      :idCliente="idCliente"
      :arbol="treeData"
      @ver-armario="dialogHistorial = false; verArmarioEnArbol({ id: $event })"
    />

    <DialogNotaArmario
      :dialog.sync="dialogNota"
      :nodo="nodoNota"
      :guardando="guardandoNota"
      @guardar="guardarNota"
    />

    <DialogElegirCarpetas
      :dialog.sync="dialogCarpetasBloque"
      :titulo="`Añadir carpetas a ${idsCarpetasBloque.length} armario${idsCarpetasBloque.length === 1 ? '' : 's'}`"
      subtitulo="Se añaden a los armarios marcados; las que ya tengan no cambian."
      solo-anadir
      texto-guardar="Añadir"
      :guardando="guardandoCarpetasBloque"
      @guardar="asignarCarpetasEnBloque"
    />

    <DialogMoverArmarios
      :dialog.sync="dialogMover"
      :ids="idsMover"
      :arbol="treeData"
      :guardando="moviendo"
      @mover="moverEnBloque"
    />

    <DialogOrdenarHijos
      :dialog.sync="dialogOrdenar"
      :nodo="nodoOrdenar"
      :guardando="guardandoOrden"
      @guardar="guardarOrdenHijos"
    />

    <DialogAsignarCategoria
      :dialog.sync="dialogAsignarCategoria"
      :nodo="nodoCategoria"
      :puedeGestionar="puedeGestionarCategorias"
      @asignar="asignarCategoria"
      @gestionar="dialogCategorias = true"
    />
  </v-container>
</template>

<script>
import ArmariosToolbar from "./layout/ArmariosToolbar.vue";
import ArmariosDrawer from "./layout/ArmariosDrawer.vue";
import ArmariosTreeView from "./views/ArmariosTreeView.vue";
import ArmariosPlanosView from "./views/ArmariosPlanosView.vue";
import ArmariosDialogs from "./dialogs/ArmariosDialogs.vue";
import DialogAdjuntosCliente from "./dialogs/DialogAdjuntosCliente.vue";
import DialogCategoriasArmarios from "./dialogs/DialogCategoriasArmarios.vue";
import DialogAsignarCategoria from "./dialogs/DialogAsignarCategoria.vue";
import DialogOrdenarHijos from "./dialogs/DialogOrdenarHijos.vue";
import DialogMoverArmarios from "./dialogs/DialogMoverArmarios.vue";
import DialogNotaArmario from "./dialogs/DialogNotaArmario.vue";
import DialogElegirCarpetas from "./dialogs/DialogElegirCarpetas.vue";
import DialogHistorialCliente from "./dialogs/DialogHistorialCliente.vue";
import DialogAyuda from "./dialogs/DialogAyuda.vue";
import DialogCalidadDatos from "./dialogs/DialogCalidadDatos.vue";


import axios from "axios";
import { mapState, mapActions } from "vuex";

export default {
  name: "Armarios",
  components: {
    ArmariosToolbar,
    ArmariosDrawer,
    ArmariosTreeView,
    ArmariosPlanosView,
    ArmariosDialogs,
    DialogAdjuntosCliente,
    DialogCategoriasArmarios,
    DialogAsignarCategoria,
    DialogOrdenarHijos,
    DialogMoverArmarios,
    DialogNotaArmario,
    DialogElegirCarpetas,
    DialogHistorialCliente,
    DialogAyuda,
    DialogCalidadDatos,
  },
  data() {
    return {
      drawerOpen: false,
      listaModo: "armarios",

      snackbar: false,
      snackbarText: "",
      snackbarColor: null,

      // Modo QR Bloqueado
      modoBloqueadoQR: false,
      nodoBloqueado: null,

      // Dialogs
      dialogSeleccionarArmario: false,
      showScanner: false,
      dialogVerQR: false,
      nodoParaQR: null,
      dialogDocsCliente: false,
      numDocsCliente: 0,

      // Categorías
      dialogCategorias: false,
      dialogAsignarCategoria: false,
      nodoCategoria: null,

      // Orden de los hijos
      dialogOrdenar: false,
      // acciones en bloque
      dialogMover: false,
      // nota interna de un armario
      dialogNota: false,
      // carpetas de documentos
      dialogCarpetasBloque: false,
      idsCarpetasBloque: [],
      guardandoCarpetasBloque: false,
      nodoNota: null,
      guardandoNota: false,
      dialogHistorial: false,
      dialogAyuda: false,
      dialogCalidad: false,
      idsMover: [],
      moviendo: false,
      nodoOrdenar: null,
      guardandoOrden: false,

      // Planos
      planosData: [],
      selectedPlano: null,
      selectedRegion: null,
      planoYposicion: {},
      dialogPlanos: false,
      dialogElegirPlano: false,
      nodoTemporal: null,
      nodoParaPlano: null,

      // Edición / Creación
      editarNodoDialog: false,
      nodoEditando: {},
      nuevoTipoTexto: "",
      nuevoTipoBanner: null,
      crearSubnodoDialog: false,
      nuevoNombreSubnodo: "",
      nuevoTipoSeleccionado: null,
      tiposSubnodo: [],
      nodoParaCrearHijo: null,

      // Adjuntos y Artículos
      tiposAdjunto: [],
      tiposNodo: [],
      attachDialog: false,
      nodoSeleccionadoParaAdjunto: null,
      carpetasParaAdjunto: [],
      carpetaParaAdjunto: null,
      adjuntos: [],
      articulos: [],
      selectedAdjuntos: null,

      // Árbol
      treeData: [],
      errorArbol: "", // si no se pudo cargar el árbol (p. ej. el portal externo no responde)
      cargandoArbol: false,
      selectedNode: null,
      treeSearchQuery: "",

      // Estado de Cliente
      idCliente: null,
    };
  },
  computed: {
    ...mapState(["user", "usuarios", "esRamos", "permisos", "idCliente as idClienteStore"]),
    ...mapState("armarios", ["regionSeleccionada"]),

    treeDataVisible() {
      if (this.modoBloqueadoQR && this.nodoBloqueado) {
        return [
          {
            ...this.nodoBloqueado,
            id_parent: null,
            expanded: true,
          },
        ];
      }
      return this.treeData;
    },

    bannerTipoSeleccionado() {
      const tipo = this.tiposNodo.find((t) => t.id === this.nuevoTipoSeleccionado);
      if (tipo && tipo.banner_url) {
        return `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs${tipo.banner_url}`;
      }
      return null;
    },

    puedeEditar() {
      return this.permisos.includes("editar-armarios");
    },
    puedeVerPlanos() {
      return this.permisos.includes("ver-planos");
    },
    puedeAdjuntar() {
      return this.permisos.includes("anadir-archivo");
    },
    // las categorías son globales (comunes a todos los clientes): solo Ramos las crea/edita/borra
    // ordenar los nodos hijos de un padre (gestor del árbol)
    puedeOrdenar() {
      return this.permisos.includes("ordenar-armarios");
    },
    puedeGestionarCategorias() {
      return this.esRamos && this.puedeEditar;
    },
    puedeEliminarAdjunto() {
      return this.permisos.includes("eliminar-archivo");
    },
  },
  watch: {
    listaModo(newMode) {
      if (newMode !== "planos") {
        this.setRegionNueva(null);
      }
    },

    // Si el selector superior en App.vue cambia el cliente
    async idClienteStore(nuevoId) {
      if (nuevoId && Number(nuevoId) !== Number(this.idCliente)) {
        await this.cambiarCliente(nuevoId);
      }
    },

    // Si cambian los query params de la ruta
    "$route.query": {
      deep: true,
      async handler(newQuery) {
        if (newQuery.qr) {
          await this.procesarLecturaQR(newQuery.qr);
        } else if (!newQuery.qr && this.modoBloqueadoQR) {
          this.modoBloqueadoQR = false;
          this.nodoBloqueado = null;
        }
      },
    },
  },
  async mounted() {
    this.cargarCarpetas(); // catálogo de carpetas de documentos (fijo)
    await this.inicializarVista();
  },
  methods: {
    ...mapActions(["setUsuarios", "setClientId", "setBloqueoQR"]),
    ...mapActions("armarios", [
      "setRegionSeleccionada",
      "setSelectedPlano",
      "setRegionNueva",
      "setSelectedNode",
      "setCategorias",
      "setCategoriaArmario",
      "cargarCarpetas",
    ]),

    // =========================================================
    // 1. HELPERS Y UTILIDADES QR
    // =========================================================

    /**
     * Extrae de forma segura el código limpio sin importar si viene como URL,
     * parámetro ?qr= o texto plano.
     */
    extraerCodigoQR(rawInput) {
      if (!rawInput) return null;
      try {
        if (rawInput.includes("http://") || rawInput.includes("https://")) {
          const urlObj = new URL(rawInput);
          return urlObj.searchParams.get("qr") || rawInput;
        }
        if (rawInput.includes("?qr=")) {
          const params = new URLSearchParams(rawInput.split("?")[1]);
          return params.get("qr") || rawInput;
        }
      } catch (e) {
        // No es una URL válida, tratar como string
      }
      return String(rawInput).trim();
    },

    buscarNodoPorQR(nodos, codigoEscaneado) {
      if (!nodos || !codigoEscaneado) return null;
      for (const nodo of nodos) {
        if (nodo.qr_code === codigoEscaneado) return nodo;
        if (nodo.children && nodo.children.length > 0) {
          const encontrado = this.buscarNodoPorQR(nodo.children, codigoEscaneado);
          if (encontrado) return encontrado;
        }
      }
      return null;
    },

    findNodeById(nodes, idBuscado) {
      if (!nodes) return null;
      for (const node of nodes) {
        if (String(node.id) === String(idBuscado)) return node;
        if (node.children && node.children.length) {
          const found = this.findNodeById(node.children, idBuscado);
          if (found) return found;
        }
      }
      return null;
    },

    // =========================================================
    // 2. GESTIÓN CENTRALIZADA DE CLIENTE Y CARGA
    // =========================================================

    /**
     * Punto único para cambiar el cliente actual, sincronizar stores
     * y recargar árbol y planos sin duplicar llamadas.
     */
    async cambiarCliente(nuevoIdCliente) {
      const idNumerico = parseInt(nuevoIdCliente, 10);
      if (!idNumerico) return;

      this.idCliente = idNumerico;
      localStorage.setItem("clienteSeleccionado", idNumerico);

      // Si el Store no lo tiene todavía, se actualiza
      if (this.idClienteStore !== idNumerico) {
        this.setClientId(idNumerico);
      }

      // Cargar los datos del cliente actual
      await Promise.all([this.fetchTree(), this.fetchPlanos(), this.fetchCategorias(), this.fetchNumDocsCliente()]);
    },

    /**
     * Inicialización limpia: averigua cliente -> carga catálogos -> procesa QR (si hay)
     */
    async inicializarVista() {
      const qrRaw = this.$route.query.qr;
      const codigoQR = this.extraerCodigoQR(qrRaw);
      let clienteDetectado = null;

      // A) Si hay QR y somos Ramos, consultamos a qué cliente pertenece
      if (codigoQR && this.esRamos) {
        try {
          const res = await axios.get(
            `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/cliente/${codigoQR}`
          );
          if (res.data?.client_id) {
            clienteDetectado = parseInt(res.data.client_id, 10);
          }
        } catch (e) {
          console.error("No se pudo resolver el cliente del QR en init:", e);
        }
      }

      // B) Determinar cliente definitivo
      const clienteFinal =
        clienteDetectado ||
        this.$route.query.client_id ||
        this.idClienteStore ||
        localStorage.getItem("clienteSeleccionado") ||
        1;

      // C) Cargar tipos y usuarios en paralelo
      this.fetchTiposAdjunto();
      this.fetchUsuarios();
      this.fetchTiposNodo();

      // D) Cargar árbol y planos para ese cliente UNA SOLA VEZ
      await this.cambiarCliente(clienteFinal);

      // E) Si venía con QR, seleccionar y bloquear directamente
      if (codigoQR) {
        this.bloquearYSeleccionarArmario(codigoQR);
      }
    },

    // =========================================================
    // 3. PROCESAMIENTO Y BLOQUEO POR QR
    // =========================================================

    /**
     * Reutilizable tanto por la URL inicial como por el escáner de cámara
     */
    async procesarLecturaQR(contenidoLeido) {
      const codigo = this.extraerCodigoQR(contenidoLeido);
      if (!codigo) return;

      // Si somos Ramos, verificamos si el QR pertenece a otro cliente
      if (this.esRamos) {
        try {
          const res = await axios.get(
            `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/cliente/${codigo}`
          );
          const idClienteQR = res.data?.client_id ? parseInt(res.data.client_id, 10) : null;

          // Si el armario es de un cliente distinto al actual, cambiamos de cliente
          if (idClienteQR && idClienteQR !== this.idCliente) {
            await this.cambiarCliente(idClienteQR);
          }
        } catch (e) {
          console.error("Error al comprobar cliente del QR:", e);
        }
      }

      this.bloquearYSeleccionarArmario(codigo);
    },

    /**
     * Aplica el estado de bloqueo al armario encontrado
     */
    bloquearYSeleccionarArmario(codigoQR) {
      const armario = this.buscarNodoPorQR(this.treeData, codigoQR);

      if (armario) {
        this.modoBloqueadoQR = true;
        this.nodoBloqueado = armario;
        this.setBloqueoQR(true);
        this.listaModo = "armarios";
        this.drawerOpen = false;

        this.selectNode(armario);
        this.viewFiles(armario);

        this.snackbarText = `Armario localizado: ${armario.name}`;
        this.snackbarColor = "success";
        this.snackbar = true;
      } else {
        this.snackbarText = "El armario del QR no se encuentra en el cliente actual.";
        this.snackbarColor = "error";
        this.snackbar = true;
      }
    },

    notificar({ text, color }) {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },

    async onDecode(codigoLeido) {
      this.showScanner = false;
      await this.procesarLecturaQR(codigoLeido);
    },

    salirModoQR() {
      this.modoBloqueadoQR = false;
      this.nodoBloqueado = null;

      // Limpiar query param ?qr sin recargar la página
      const query = { ...this.$route.query };
      delete query.qr;
      this.$router.replace({ query }).catch(() => {});
    },

    onIntentarSeleccionarNodo(node) {
      if (this.modoBloqueadoQR && this.nodoBloqueado && node.id !== this.nodoBloqueado.id) {
        return; // No permitir navegar a otro nodo mientras esté bloqueado
      }
      this.selectNode(node);
    },

    // =========================================================
    // 4. PETICIONES HTTP Y OPERACIONES CRUD
    // =========================================================

    async fetchPlanos() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/planos`,
          { params: { id_cliente: this.idCliente } }
        );
        this.planosData = response.data || [];
      } catch (error) {
        console.error("Error al cargar planos:", error);
      }
    },

    // Número de documentos generales del cliente (contador del botón de la barra)
    async fetchNumDocsCliente() {
      if (!this.idCliente || !this.esRamos) return; // los documentos generales son solo de Ramos
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/clientes/${this.idCliente}/adjuntos`
        );
        this.numDocsCliente = (data.adjuntos || []).length;
      } catch (error) {
        console.error("Error al contar los documentos del cliente:", error);
        this.numDocsCliente = 0;
      }
    },

    async fetchCategorias() {
      if (!this.idCliente) return;
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/clientes/${this.idCliente}/categorias`
        );
        this.setCategorias(data);
      } catch (error) {
        console.error("Error al cargar categorías:", error);
        this.setCategorias({ categorias: [], asignaciones: [] });
      }
    },

    abrirOrdenarHijos(node) {
      this.nodoOrdenar = node;
      this.dialogOrdenar = true;
    },

    async guardarOrdenHijos({ ids }) {
      this.guardandoOrden = true;
      try {
        await axios.put(`${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/orden`, {
          id_cliente: this.idCliente,
          ids,
        });
        await this.fetchTree();
        this.dialogOrdenar = false;
        this.notificar({ text: "Orden guardado", color: "success" });
      } catch (error) {
        console.error("Error al guardar el orden:", error);
        this.notificar({ text: error.response?.data?.error || "No se pudo guardar el orden", color: "error" });
      } finally {
        this.guardandoOrden = false;
      }
    },

    abrirAsignarCategoria(node) {
      this.nodoCategoria = node;
      this.dialogAsignarCategoria = true;
    },

    async asignarCategoria({ nodo, id_categoria }) {
      try {
        await axios.put(
          `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/clientes/${this.idCliente}/armarios/${nodo.id}/categoria`,
          { id_categoria }
        );
        this.setCategoriaArmario({ id_armario: nodo.id, id_categoria });
        this.dialogAsignarCategoria = false;
      } catch (error) {
        console.error("Error al asignar categoría:", error);
        this.notificar({ text: "No se pudo asignar la categoría", color: "error" });
      }
    },

    // ---- CARPETAS DE DOCUMENTOS ----
    abrirCarpetasEnBloque(ids) {
      this.idsCarpetasBloque = [...ids];
      this.dialogCarpetasBloque = true;
    },

    async asignarCarpetasEnBloque(carpetas) {
      this.guardandoCarpetasBloque = true;
      try {
        await axios.post(`${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/clientes/${this.idCliente}/carpetas/asignar`, {
          armarios: this.idsCarpetasBloque,
          carpetas,
        });
        this.dialogCarpetasBloque = false;
        this.$avisar(`Carpetas añadidas a ${this.idsCarpetasBloque.length} armario${this.idsCarpetasBloque.length === 1 ? "" : "s"}`, "success");
        this.$refs.arbol?.terminarAccionEnBloque();
      } catch (error) {
        this.$avisar(error.response?.data?.error || "No se pudieron añadir las carpetas", "error");
      } finally {
        this.guardandoCarpetasBloque = false;
      }
    },

    // ---- NOTA DEL ARMARIO ----
    abrirNota(nodo) {
      this.nodoNota = nodo;
      this.dialogNota = true;
    },

    async guardarNota({ nodo, nota }) {
      this.guardandoNota = true;
      try {
        await axios.put(`${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/${nodo.id}/nota`, {
          nota,
          id_cliente: this.idCliente,
        });
        // se actualiza en el árbol sin recargarlo (para no plegar lo desplegado)
        const enArbol = this.findNodeById(this.treeData, nodo.id);
        if (enArbol) this.$set(enArbol, "nota", nota);
        if (this.selectedAdjuntos && this.selectedAdjuntos.id === nodo.id) this.$set(this.selectedAdjuntos, "nota", nota);
        this.dialogNota = false;
        this.$avisar(nota ? "Nota guardada" : "Nota borrada", "success");
      } catch (error) {
        console.error("Error al guardar la nota:", error);
        this.$avisar(error.response?.data?.error || "No se pudo guardar la nota", "error");
      } finally {
        this.guardandoNota = false;
      }
    },

    // ---- ACCIONES EN BLOQUE (selección múltiple del árbol) ----
    async asignarCategoriaEnBloque({ ids, id_categoria }) {
      let fallos = 0;
      for (const id of ids) {
        try {
          await axios.put(
            `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/clientes/${this.idCliente}/armarios/${id}/categoria`,
            { id_categoria }
          );
          this.setCategoriaArmario({ id_armario: id, id_categoria });
        } catch (error) {
          console.error(`Error al asignar la categoría al armario ${id}:`, error);
          fallos++;
        }
      }
      const hechos = ids.length - fallos;
      const accion = id_categoria ? "Categoría asignada" : "Categoría quitada";
      if (fallos) this.$avisar(`${accion} a ${hechos} de ${ids.length}. ${fallos} no se pudieron cambiar.`, "warning");
      else this.$avisar(`${accion} a ${hechos} armario${hechos > 1 ? "s" : ""}`, "success");
      this.$refs.arbol?.terminarAccionEnBloque();
    },

    abrirMoverEnBloque(ids) {
      this.idsMover = [...ids];
      this.dialogMover = true;
    },

    async moverEnBloque({ ids, id_parent }) {
      this.moviendo = true;
      let fallos = 0;
      for (const id of ids) {
        try {
          await axios.put(`${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/${id}/change-parent`, { id_parent });
        } catch (error) {
          console.error(`Error al mover el armario ${id}:`, error);
          fallos++;
        }
      }
      this.moviendo = false;
      this.dialogMover = false;
      await this.fetchTree();
      const hechos = ids.length - fallos;
      if (fallos) this.$avisar(`Movidos ${hechos} de ${ids.length}. ${fallos} no se pudieron mover.`, "warning");
      else this.$avisar(`${hechos} armario${hechos > 1 ? "s" : ""} movido${hechos > 1 ? "s" : ""}`, "success");
      this.$refs.arbol?.terminarAccionEnBloque();
    },

    async fetchTree() {
      this.cargandoArbol = true;
      try {
        const id_usuario = this.user?.id || JSON.parse(localStorage.getItem("user"))?.id;
        const response = await axios.get(
          `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios`,
          { params: { id_cliente: this.idCliente, id_usuario } }
        );
        this.treeData = response.data.armarios || [];
        this.errorArbol = "";

        // Si estábamos en modo QR, actualizar la referencia del nodo bloqueado
        if (this.modoBloqueadoQR && this.nodoBloqueado) {
          const actualizado = this.findNodeById(this.treeData, this.nodoBloqueado.id);
          if (actualizado) {
            this.nodoBloqueado = actualizado;
            this.selectNode(actualizado);
          }
        }
      } catch (err) {
        console.error("Error al cargar árbol:", err);
        // sin árbol: mejor un aviso con "Reintentar" que un árbol vacío (o el del cliente anterior)
        this.treeData = [];
        this.errorArbol = err.response?.data?.error || "No se han podido cargar los armarios.";
      } finally {
        this.cargandoArbol = false;
      }
    },

    fetchUsuarios() {
      axios
        .get(`${process.env.VUE_APP_LOCAL_BASE_URL}/api/django/portal/get_all_users`)
        .then((response) => this.setUsuarios(response.data.users || []))
        .catch((error) => console.error("Error al cargar usuarios:", error));
    },

    fetchTiposAdjunto() {
      axios
        .get(`${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/tipos_adjuntos`)
        .then((response) => (this.tiposAdjunto = response.data.tipos || []))
        .catch((error) => console.error("Error al cargar tipos de adjuntos:", error));
    },

    fetchTiposNodo() {
      axios
        .get(`${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/tipos`)
        .then((response) => (this.tiposNodo = response.data.tipos_armarios || []))
        .catch((error) => console.error("Error al cargar tipos de nodo:", error));
    },

    // ====== Modos y Navegación ======
    onChangeModo(modo) {
      if (this.modoBloqueadoQR) return;
      this.listaModo = modo;
      this.clearSelectedNode();
      this.clearSearchQuery();
      if (modo === "planos") this.entrarModoPlanos();
      else this.selectedPlano = null;
    },

    entrarModoPlanos() {
      this.listaModo = "planos";
      if (!this.$vuetify.breakpoint.mdAndUp) {
        this.selectedPlano = null;
      }
    },

    clearSelectedNode() {
      this.selectedNode = null;
    },

    /** Pliega o despliega todos los nodos del árbol */
    cambiarDesplegadoTodo(desplegado) {
      const recorrer = (nodos) => (nodos || []).forEach((n) => {
        if (n.children && n.children.length) n.expanded = desplegado;
        recorrer(n.children);
      });
      recorrer(this.treeData);
    },

    toggle(node) {
      node.expanded = !node.expanded;
    },

    findParentInTree(tree, node) {
      for (const n of tree) {
        if (n.id === node.id_parent) return n;
        const found = this.findParentInTree(n.children || [], node);
        if (found) return found;
      }
      return null;
    },

    expandParents(node) {
      let current = node;
      while (current && current.id_parent !== null) {
        const parent = this.findParentInTree(this.treeData, current);
        if (!parent) break;
        parent.expanded = true;
        current = parent;
      }
    },

    selectNode(node) {
      this.selectedNode = node;
      this.setSelectedNode(node);

      const collapseAll = (nodes) => {
        nodes.forEach((n) => {
          n.expanded = false;
          if (n.children && n.children.length) collapseAll(n.children);
        });
      };

      collapseAll(this.treeData);
      this.expandParents(node);
    },

    // ====== Armarios CRUD ======
    crearArmarioRaizFromChild(nombre) {
      return this.crearArmarioRaiz(nombre);
    },

    async crearArmarioRaiz(nombre) {
      const name = (nombre || "").trim();
      if (!name) return;

      const newNode = {
        name,
        parent_id: null,
        x: 50,
        y: 250,
        expanded: true,
        children: [],
        id_cliente: this.idCliente,
        id_usuario: this.user?.id || JSON.parse(localStorage.getItem("user"))?.id,
      };

      try {
        await axios.post(`${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios`, newNode);
        await this.fetchTree();
        this.snackbarText = "Armario creado correctamente";
        this.snackbarColor = "success";
        this.snackbar = true;
      } catch (error) {
        console.error("Error al crear armario:", error);
      }
    },

    async crearHijo(parentNode) {
      this.nodoParaCrearHijo = parentNode;
      this.nuevoNombreSubnodo = "";
      this.nuevoTipoSeleccionado = null;
      this.nuevoTipoTexto = "";
      this.nuevoTipoBanner = null;
      this.crearSubnodoDialog = true;

      if (this.tiposSubnodo.length === 0) {
        try {
          const res = await axios.get(
            `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/tipos_adjuntos`
          );
          this.tiposSubnodo = res.data.tipos || [];
        } catch (error) {
          console.error("Error cargando tipos:", error);
        }
      }
    },

    async guardarSubnodo(payload) {
      const { nombre, tipoSeleccionado, tipoNuevoTexto, tipoNuevoBanner } = payload;

      if (!nombre || !nombre.trim()) {
        this.$avisar("Debes poner un nombre para el subnodo", "warning");
        return;
      }

      let tipoFinal = tipoSeleccionado;

      if (!tipoFinal && tipoNuevoTexto && tipoNuevoTexto.trim()) {
        try {
          if (!tipoNuevoBanner) {
            this.$avisar("Debes subir un banner para crear un nuevo tipo", "warning");
            return;
          }

          const formData = new FormData();
          formData.append("name", tipoNuevoTexto.trim());
          formData.append("banner", tipoNuevoBanner);

          const res = await axios.post(
            `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/tipos`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
          );

          tipoFinal = res.data.id;
          await this.fetchTiposNodo();
        } catch (err) {
          console.error(err);
          this.$avisar("No se pudo crear el tipo nuevo", "error");
          return;
        }
      }

      if (!tipoFinal) {
        this.$avisar("Debes seleccionar o crear un tipo", "warning");
        return;
      }

      try {
        const payloadSubnodo = {
          name: nombre,
          id_parent: this.nodoParaCrearHijo.id,
          id_tipo: tipoFinal,
          x: (this.nodoParaCrearHijo.x || 0) + 150,
          y: (this.nodoParaCrearHijo.y || 0) + 100,
          id_cliente: this.idCliente,
          id_usuario: this.user?.id || JSON.parse(localStorage.getItem("user"))?.id,
          tipo: tipoFinal,
          expanded: true,
        };

        const res = await axios.post(
          `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios`,
          payloadSubnodo
        );

        await this.fetchTree();

        this.selectNode({
          id: res.data.id,
          name: nombre,
          id_parent: this.nodoParaCrearHijo.id,
          x: payloadSubnodo.x,
          y: payloadSubnodo.y,
          expanded: true,
          children: [],
          id_usuario: payloadSubnodo.id_usuario,
          tipo: tipoFinal,
        });

        this.crearSubnodoDialog = false;
      } catch (error) {
        console.error("Error al crear subnodo:", error);
        this.$avisar("Error al crear subnodo", "error");
      }
    },

    async editTitle(node) {
      this.nodoEditando = { ...node };

      if (typeof node.tipo === "string") {
        const partes = node.tipo.replace(/[()"]/g, "").split(",");
        this.nodoEditando.tipoId = Number(partes[0]);
      } else {
        this.nodoEditando.tipoId = node.tipoId || node.id_tipo || null;
      }

      this.editarNodoDialog = true;
    },

    async guardarEdicionNodo() {
      try {
        const copiaNodo = { ...this.nodoEditando };

        await axios.put(
          `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/${this.nodoEditando.id}`,
          {
            name: this.nodoEditando.name,
            tipoId: this.nodoEditando.tipoId,
            id_usuario: this.user?.id || JSON.parse(localStorage.getItem("user"))?.id,
            id_cliente: localStorage.getItem("clienteSeleccionado"),
          }
        );

        this.editarNodoDialog = false;
        await this.fetchTree();

        this.snackbarText = "Nodo actualizado correctamente";
        this.snackbarColor = "success";
        this.snackbar = true;

        this.selectNode(copiaNodo);
      } catch (err) {
        console.error(err);
      }
    },

    crearNuevoTipo() {
      console.log("crearNuevoTipo", this.nuevoTipoTexto, this.nuevoTipoBanner);
    },

    findRealParent(node) {
      if (!node || !node.id_parent) return null;
      for (const n of this.treeData) {
        if (n.id === node.id_parent) return n;
        const found = this.findParentInTree(n.children || [], node);
        if (found) return found;
      }
      return null;
    },

    async removeNode(node) {
      const ok = await this.$confirmar({
        titulo: "Eliminar armario",
        texto: `Se eliminará el armario "${node.name}".`,
        peligro: true,
      });
      if (!ok) return;

      try {
        await axios.delete(
          `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/${node.id}`,
          {
            data: {
              id_cliente: localStorage.getItem("clienteSeleccionado"),
            },
          }
        );

        const parent = this.findRealParent(node);
        if (parent) {
          parent.children = (parent.children || []).filter((child) => child.id !== node.id);
        }

        await this.fetchTree();
        if (parent) this.selectNode(parent);
      } catch (error) {
        console.error("Error al eliminar armario:", error);
      }
    },

    // ====== Adjuntos ======
    // desde el menú del nodo: se cargan sus carpetas para elegir en cuál va
    async attachFile(node) {
      this.nodoSeleccionadoParaAdjunto = node;
      this.carpetaParaAdjunto = null;
      this.carpetasParaAdjunto = await this.carpetasDeArmario(node.id);
      // los documentos van siempre en una carpeta: sin carpetas, a la documentación para elegirlas
      if (!this.carpetasParaAdjunto.length) {
        this.$avisar("Este armario no tiene carpetas: elige primero en cuáles se guardarán sus documentos", "warning");
        this.viewFiles(node);
        return;
      }
      this.attachDialog = true;
    },

    async carpetasDeArmario(idArmario) {
      try {
        const { data } = await axios.get(`${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/clientes/${this.idCliente}/armarios/${idArmario}/carpetas`);
        return data.carpetas || [];
      } catch (error) {
        console.error("Error al cargar las carpetas del armario:", error);
        return [];
      }
    },

    async handleFileUpload(payload) {
      const { nombreArchivo, descripcionArchivo, archivoAdjunto, idCarpeta } = payload;

      if (!archivoAdjunto || !nombreArchivo || !nombreArchivo.trim()) {
        this.$avisar("Por favor, selecciona un archivo y proporciona un nombre.", "warning");
        return;
      }

      const formData = new FormData();
      formData.append("archivo", archivoAdjunto);
      formData.append("name", nombreArchivo);
      formData.append("description", descripcionArchivo || "");
      formData.append("id_usuario", this.user?.id || JSON.parse(localStorage.getItem("user"))?.id);
      formData.append("tipo", "armario");
      formData.append("id_cliente", localStorage.getItem("clienteSeleccionado"));
      formData.append("id_carpeta", idCarpeta);

      try {
        await axios.post(
          `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/${this.nodoSeleccionadoParaAdjunto.id}/adjuntos`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        await this.fetchTree();
        this.snackbarText = "Archivo subido correctamente";
        this.snackbarColor = "success";
        this.snackbar = true;

        this.selectNode(this.nodoSeleccionadoParaAdjunto);

        this.attachDialog = false;

        if (this.selectedAdjuntos && this.selectedAdjuntos.id === this.nodoSeleccionadoParaAdjunto?.id) {
          this.viewFiles(this.selectedAdjuntos);
        }
        this.nodoSeleccionadoParaAdjunto = null;
      } catch (error) {
        console.error("Error al adjuntar archivo:", error);
        // p. ej. la carpeta está llena
        this.$avisar(error.response?.data?.error || "Error al adjuntar archivo", "error");
      }
    },

    async viewFiles(node) {
      try {
        const id_cliente = localStorage.getItem("clienteSeleccionado");
        const [adjuntosResponse, articulosResponse] = await Promise.all([
          axios.get(
            `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/${node.id}/adjuntos`,
            { params: { id_cliente } }
          ),
          // los artículos son un extra: si fallan, la documentación se abre igual
          axios
            .get(`${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/articulos/articulos-armarios/${node.id}`, { params: { id_cliente } })
            .catch((error) => {
              console.error("Error al obtener los artículos del armario:", error);
              return { data: { articulos: [] } };
            }),
        ]);

        this.adjuntos = adjuntosResponse.data.adjuntos || [];
        this.adjuntos.forEach((adjunto) => {
          adjunto.usuario = this.usuarios.find((u) => u.id === adjunto.id_usuario) || {
            // con portal externo (Quesos) el portal devuelve el nombre de quien lo subió
            username: (typeof adjunto.usuario === "string" && adjunto.usuario) || "Desconocido",
          };
        });

        this.articulos = articulosResponse.data.articulos || [];
        this.selectedAdjuntos = node;
      } catch (error) {
        console.error("Error al obtener articulos o archivos adjuntos", error);
        this.$avisar(
          error.response?.status === 403 ? "No tienes acceso a la documentación de este armario" : "No se pudo abrir la documentación del armario",
          "error"
        );
      }
    },

    refreshAdjuntos() {
      if (this.selectedAdjuntos) this.viewFiles(this.selectedAdjuntos);
    },

    async closeAdjuntosLista() {
      if (this.modoBloqueadoQR) return; // en acceso por QR el diálogo no se puede cerrar
      await this.fetchTree();
      if (this.selectedAdjuntos) this.selectNode(this.selectedAdjuntos);
      this.selectedAdjuntos = null;
      this.adjuntos = [];
    },

    // ====== Planos ======
    selectPlano(plano) {
      if (this.modoBloqueadoQR) return;
      this.selectedPlano = plano;
      this.setSelectedPlano(plano);
      this.listaModo = "planos";
    },

    click_plano(plano) {
      this.selectNode(plano);
      this.viewFiles(plano);
      this.listaModo = "armarios";
    },

    async verPlano(nodo) {
      if (this.modoBloqueadoQR) return;

      this.setRegionSeleccionada(nodo);

      try {
        const url = `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/planos/armario/${nodo.id}?id_cliente=${localStorage.getItem("clienteSeleccionado")}`;
        const resul = await axios.get(url);

        if (!resul.data || resul.data.length === 0) {
          const crear = await this.$confirmar({
            titulo: "Sin plano",
            texto: `"${nodo.name}" no está en ningún plano. ¿Quieres colocarlo en uno?`,
            aceptar: "Elegir plano",
            icono: "mdi-floor-plan",
          });
          if (crear) {
            this.nodoTemporal = nodo;
            this.dialogElegirPlano = true;
            return;
          }
          this.snackbarText = "No hay plano asociado a este armario.";
          this.snackbarColor = "info";
          this.snackbar = true;
          return;
        }

        const infoPlano = resul.data[0];
        this.planoYposicion = infoPlano;
        this.selectedRegion = nodo;

        this.clearSearchQuery();
        this.clearSelectedNode();

        this.dialogPlanos = true;
      } catch (error) {
        console.error("[Armarios] Error en verPlano:", error);
      }
    },

    selectPlanoStore(plano) {
      this.setSelectedPlano(plano);
      this.setRegionNueva(this.nodoTemporal);
      this.dialogElegirPlano = false;
      this.selectedPlano = plano;

      this.$nextTick(() => {
        this.listaModo = "planos";
      });
    },

    cerrarDialogPlanos() {
      this.planoYposicion = {};
      this.nodoParaPlano = null;

      const tieneRegionSeleccionada =
        this.regionSeleccionada &&
        typeof this.regionSeleccionada === "object" &&
        (this.regionSeleccionada.id != null || this.regionSeleccionada.id_armario != null);

      if (tieneRegionSeleccionada) {
        this.setRegionSeleccionada(null);
      }

      this.dialogPlanos = false;
      if (this.listaModo == "armarios") {
        this.selectedPlano = null;
        this.setSelectedPlano(null);
      }
    },

    // ====== QR Impresión ======
    verQR(node) {
      this.nodoParaQR = node;
      this.dialogVerQR = true;
    },

    imprimirQR() {
      const elemento = document.getElementById("print-section");
      if (!elemento) return;

      const canvas = elemento.querySelector("canvas");
      let contenidoFinal = "";

      if (canvas) {
        const imagenData = canvas.toDataURL("image/png");
        // debajo del QR solo va el código de la intranet, si lo tiene (escapado: es texto libre)
        const codigo = (this.nodoParaQR?.codigo_intranet || "").trim();
        const textoIdentificador = codigo.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

        contenidoFinal = `
          <div style="text-align:center; font-family: sans-serif;">
            <img src="${imagenData}" style="width:200px; height:200px;" />
            ${textoIdentificador ? `<div style="margin-top:10px; font-size: 18px; font-weight: bold;">${textoIdentificador}</div>` : ""}
          </div>
        `;
      } else {
        contenidoFinal = elemento.innerHTML;
      }

      const ventana = window.open("", "_blank");
      ventana.document.write("<html><head><title>Imprimir QR</title></head><body>");
      ventana.document.write(contenidoFinal);
      ventana.document.write(
        `
        <script>
          window.onload = function() {
            setTimeout(function() {
              window.print();
              window.close();
            }, 500);
          };
        <` + "/script>"
      );
      ventana.document.write("</body></html>");
      ventana.document.close();
    },

    select(nodo) {
      this.planoYposicion = nodo;
    },

    irASubPlano(payload) {
      if (this.modoBloqueadoQR) return;

      const localListaModo = this.listaModo;
      const idPlanoDestino = payload?.id;
      if (!idPlanoDestino) {
        console.warn("No llegó id de subplano", payload);
        return;
      }

      const planoDestino = this.planosData.find(
        (p) => String(p.id) === String(idPlanoDestino)
      );

      if (!planoDestino) {
        console.warn("No se encontró el plano destino en planosData", idPlanoDestino);
        this.snackbarText = "No se encontró el subplano seleccionado";
        this.snackbarColor = "warning";
        this.snackbar = true;
        return;
      }

      this.selectPlano(planoDestino);
      this.listaModo = localListaModo;
    },

    // desde la ventana del armario llega { region, id_carpeta, carpetas } (o solo el armario)
    async openAttachFromAdjuntos(payload) {
      const region = payload && payload.region ? payload.region : payload;
      this.nodoSeleccionadoParaAdjunto = region;
      this.carpetaParaAdjunto = payload?.id_carpeta ?? null;
      this.carpetasParaAdjunto = payload?.carpetas || await this.carpetasDeArmario(region.id_armario || region.id);
      this.attachDialog = true;
    },

    async verArmarioEnPlano(region) {
      if (this.modoBloqueadoQR) return;
      await this.closeAdjuntosLista();
      this.verPlano(region);
    },

    async verArmarioEnArbol(region) {
      await this.closeAdjuntosLista();

      this.dialogPlanos = false;
      this.listaModo = "armarios";
      this.treeSearchQuery = `$${region.id}`;
      this.selectedPlano = null;

      this.$nextTick(() => {
        const nodo = this.findNodeById(this.treeData, region.id);
        if (nodo) {
          this.selectNode(nodo);
        } else {
          console.warn("No se encontró el nodo en el árbol con id:", region.id);
        }
      });
    },

    async clearSearchQuery() {
      this.treeSearchQuery = "";
    },

    cambiarPadre(nodo) {
      this.cambiarEstadoDialog(true);
      this.nodoParaCrearHijo = nodo;
    },

    cambiarEstadoDialog(estado) {
      this.dialogSeleccionarArmario = estado;
    },

    async cambiarPadreDeArmario({ idHijo, idNuevoPadre }) {
      this.cambiarEstadoDialog(false);
      try {
        await axios.put(
          `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/${idHijo}/change-parent`,
          { id_parent: idNuevoPadre }
        );

        await this.fetchTree();
      } catch (error) {
        console.error("Error cambiando padre del armario");
      }
    },
  },
};
</script>

<style scoped>
.main-workspace {
  overflow-y: auto;
  height: 100%;
  background-color: #f5f7fa;
}
</style>